const paymentGatewayHosts = ['pay.autopay.eu', 'testpay.autopay.eu']

export default paymentGatewayHosts
